// @flow
import {kebabCase} from 'lodash';

export const generateId = (text: string): string =>
  kebabCase(text.slice(0, 16));
